"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBicForbidden = void 0;
const forbiddenBics = ['AFRIFRPP', 'AFRIFRPPXXX'];
/**
 * Checks if the given BIC is forbidden.
 * Forbidden BICs are such because users often
 * type them by mistake.
 * In this case, submitting AFRIFRPP (Bank Of Africa) in place of
 * AGRIFRPP (Credit Agricole).
 */
const isBicForbidden = (bic) => forbiddenBics.includes(bic);
exports.isBicForbidden = isBicForbidden;
